import Vue from 'vue'
import Router from 'vue-router'
import History from '@/components/history'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    component: History
  }, ]
})



// WEBPACK FOOTER //
// ./src/router/index.js